'use client';
import { useEffect, useState } from 'react';

import {
  AutoTabs,
  IconDavinciResolve,
  IconPremierPro,
  Spacing,
} from '@kezios/design-system';
import { Flex, Text } from '@mantine/core';
import { CompatibilityBadge } from 'components/website/components/molecules/CompatibilityBadge/CompatibilityBadge';

import { CaptionVideo } from '../../../components/videos/CaptionVideo/CaptionVideo';
import { PodcastVideo } from '../../../components/videos/PodcastVideo/PodcastVideo';
import { ResizeVideo } from '../../../components/videos/ResizeVideo/ResizeVideo';
import { SilenceVideo } from '../../../components/videos/SilenceVideo/SilenceVideo';
import { ZoomVideo } from '../../../components/videos/ZoomVideo/ZoomVideo';
import css from './HeroRightSection.module.css';

const VIDEOS = [
  {
    label: 'Captions',
    component: CaptionVideo,
  },
  {
    label: 'Silences',
    component: SilenceVideo,
  },
  {
    label: 'Podcast',
    component: PodcastVideo,
  },
  {
    label: 'AutoZoom',
    component: ZoomVideo,
  },
  {
    label: 'Resize AI',
    component: ResizeVideo,
  },
];

export const HeroRightSection = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const currentVideo = VIDEOS[currentVideoIndex];
  const VideoComponent = currentVideo.component;

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  return (
    <Flex
      className={css.container}
      style={{ height: '507px' }}
      justify={'center'}
    >
      <Flex direction="column" align="center" gap={Spacing.s12}>
        <AutoTabs
          tabs={VIDEOS}
          currentTab={currentVideoIndex}
          setCurrentTab={setCurrentVideoIndex}
        />
        <VideoComponent
          key={currentVideo.label}
          scrollPosition={scrollPosition}
          onEnded={() => {
            setCurrentVideoIndex(previous => (previous + 1) % VIDEOS.length);
          }}
        />
      </Flex>

      <CompatibilityBadge
        compatibilities={[
          <Flex key={1} align="center" gap={Spacing.s2}>
            <IconPremierPro size={24} />
            <Text variant="textLg.medium" c="gray.9">
              Premiere Pro
            </Text>
          </Flex>,
          <Flex key={1} align="center" gap={Spacing.s2}>
            <IconDavinciResolve size={24} />
            <Text variant="textLg.medium" c="gray.9">
              Davinci Resolve
            </Text>
          </Flex>,
        ]}
      />
    </Flex>
  );
};
